module.exports = __webpack_public_path__ + "static/media/login.dfde9fb1.png";